import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';

const detailRoute = `${DomainByEnv()}/detail`;

function* setItinerariesAsync(
    action: actions.I_ItinerariesAction
): Generator<StrictEffect, any, any> {
    const itineraries = yield call(fetchAPI, {
        url: `${detailRoute}/daytripinfojson`,
        req: action.payload,
    });

    yield put(actions.setItinerariesSUCCESS(itineraries));
}

export function* watchSetItinerariesAsync() {
    yield takeLatest(actionTypes.SET_ITINERARIES, setItinerariesAsync);
}

function* setNoticeInfoAsync(
    action: actions.I_NoticeinfoAction
): Generator<StrictEffect, any, any> {
    const data = yield call(fetchAPI, {
        url: `${detailRoute}/noticeinfojson`,
        req: action.payload,
    });
    yield put(actions.setsetNoticeinfoSUCCESS(data));
}

export function* watchsetNoticeInfoAsync() {
    yield takeLatest(actionTypes.SET_NOTICEINFO, setNoticeInfoAsync);
}

function* setPoiAsync(action: actions.I_PoiAction): Generator<StrictEffect, any, any> {
    const loadingData = {
        DayID: null,
        POIID: null,
        Name: null,
        ImgList: null,
        ImgMList: null,
        Introduction: null,
        Longtitude: null,
        Latitude: null,
        Address: null,
        PhoneList: [],
        WebUrl: null,
        Grade: [],
        CheckIn: null,
        CheckOut: null,
    };
    yield put(actions.setPoiSUCCESS(loadingData));
    const data = yield call(fetchAPI, {
        url: `${detailRoute}/poiinfojson`,
        req: action.payload,
    });
    yield put(actions.setPoiSUCCESS(data));
}

export function* watchPoiAsync() {
    yield takeLatest(actionTypes.SET_POI, setPoiAsync);
}

function* setStationInfoAsync(
    action: actions.I_StationInfoAction
): Generator<StrictEffect, any, any> {
    const station = yield call(fetchAPI, {
        url: `${detailRoute}/stationinfojson`,
        req: action.payload,
    });

    yield put(actions.setStationInfoSUCCESS(station));
}

function* watchSetStationInfoAsync() {
    yield takeLatest(actionTypes.SET_STATIONINFO, setStationInfoAsync);
}

export default [
    watchSetItinerariesAsync(),
    watchsetNoticeInfoAsync(),
    watchPoiAsync(),
    watchSetStationInfoAsync(),
];
